// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"665695d5","455":"e3ede2d1","977":"716cf263"}[chunkId] + ".chunk.js";
};